import { API_HOST } from "../configs/api.js";
import { deleteRequest, getRequest, postRequest } from "./request.js";
import { hideLoader, showLoader } from "./utils.js";

const updateVideoList = async (
  editor,
  pathName,
  videoComponent,
  setMsg,
  setError,
  presentation
) => {
  try {
    const response = await getRequest(`assets/${pathName}/listVideos`);
    const videoListHolder = document.querySelector("#video-list-group");

    if (response.data.isSuccess) {
      let list = "";
      const sharedVideos = response.data.videos.shared;
      const keyMessageVideos = response.data.videos.keyMessage;

      // adding shared videos
      sharedVideos.forEach((videoInfo) => {
        const { videoName, videoSrc } = videoInfo;
        list += `<li class="video-list-item list-group-item d-flex justify-content-between" videoName="${videoName}" style="cursor: pointer" data-video-src="${videoSrc}">
            <span class="text-break">${videoName}</span>
            <span class="badge bg-primary" title="This video is a shared asset">Shared</span>
        </li>`;
      });

      // adding key message videos
      keyMessageVideos.forEach((videoInfo) => {
        const { videoName,videoSrc } = videoInfo;
        let src = videoSrc.replace(`${API_HOST}assets/${pathName}/`, "");
        // console.log(videoSrc.replace(`${API_HOST}assets/${pathName}/`,'').startsWith(`${presentation.structure.videos[0]}`))
        if (pathName.startsWith("imports")) {
          if (src.startsWith(`${presentation.structure.videos[0]}`)) {
            list += `<li class="video-list-item list-group-item d-flex justify-content-between" videoName="${videoName}" style="cursor: pointer" data-video-src="${videoSrc}">
            <span class="text-break">${videoName}</span>
            <span class="delete-video btn btn-outline-danger btn-sm" role="button" style="border-radius: 5px !important;">X</span>
        </li>`;
          } else {
            list += `<li class="video-list-item list-group-item d-flex justify-content-between" videoName="${videoName}" style="cursor: pointer" data-video-src="${videoSrc}">
          <span class="text-break">${videoName}</span>
          <span class="badge bg-primary" title="This video is a non deletable asset">Non deletable</span>
          </li>`;
          }
        } else {
          list += `<li class="video-list-item list-group-item d-flex justify-content-between" videoName="${videoName}" style="cursor: pointer" data-video-src="${videoSrc}">
        <span class="text-break">${videoName}</span>
        <span class="delete-video btn btn-outline-danger btn-sm" role="button" style="border-radius: 5px !important;">X</span>
    </li>`;
        }
      });

      videoListHolder.innerHTML = list;
    } else {
      videoListHolder.innerHTML = `<li class="list-group-item d-flex text-danger">
            No videos available !!
        </li>`;
    }
  } catch (error) {
    setError(true);
    setMsg(error);
  }

  let deleteVideoButtons = document.querySelectorAll("span.delete-video");
  deleteVideoButtons.forEach((deleteButton) => {
    deleteButton.addEventListener("click", async (e) => {
      e.stopImmediatePropagation();
      try {
        let videoName =
          e.target.parentNode.getElementsByTagName("span")[0].innerHTML;

        const userConfirmation = window.confirm(
          `Are you sure you want to delete ${videoName}`
        );

        if (userConfirmation) {
          const response = await deleteRequest(
            `assets/${pathName}/videos/${videoName}`
          );
          if (response.data.isSuccess) {
            e.target.parentNode.remove();
          } else {
            if (response.data.message) {
              setError(true);
              setMsg(response.data.message);
            }
          }
        }

        const videoSrc =
          deleteButton.parentElement.getAttribute("data-video-src");

        let videoComponents = editor.getWrapper().findType("video");
        for (let video of videoComponents) {
          if (video.getTrait("src").attributes.value === videoSrc) {
            videoComponent.set({
              src: "",
            });
          }
        }
      } catch (error) {
        setError(true);
        setMsg(error);
      }
    });
  });

  let videoListItems = document.querySelectorAll(".video-list-item");
  videoListItems.forEach((videoListItem) => {
    videoListItem.addEventListener("click", async (e) => {
      e.stopImmediatePropagation();
      
      const videoSrc = videoListItem.getAttribute("data-video-src");

      videoComponent.set({
        src: videoSrc,
      });

      document.querySelector("#upload-video").classList.add("d-none");
    });
  });
};

export const createVideoManager = async (
  editor,
  pathName,
  videoComponent,
  setMsg,
  setError,
  presentation
) => {
  const videoDiv = document.querySelector("#upload-video");

  if (videoDiv.classList.contains("d-none")) {
    videoDiv.classList = "";
    videoDiv.innerHTML = "";
  }

  let modal = `<div class="fade modal show" role="dialog" aria-modal="true" style="display: block;">
        <div style="padding-right: 17px; display: block;" class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h5">Video Manager</div>&nbsp
                    <button class="btn-close" aria-label="close"></button>
                </div>
                <div class="modal-body">
                    <div style="height: 300px" id="video-upload-container">
                        <div class="row">
                            <div class="col" style="border-right: 1px solid #ccc; height: 280px">
                                <form>
                                    <div class="form-group">
                                        <label for="videoFile">Select Video</label>
                                        <input type="file" accept="video/*" class="form-control" name="videoFile" id="videoFile" />
                                    </div>
                                    <div class="form-group">
                                        <button id="submit-video" class="btn btn-primary">Add Video</button>
                                    </div>
                                </form>
                            </div>
                            <div class="col" style="height: 280px; overflow: scroll">
                                <div id="video-list">
                                    <h6>Videos for this design</h6>
                                    <ul class="list-group" id="video-list-group"></ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="fade modal-backdrop show"></div>`;

  videoDiv.innerHTML = modal;

  // module toggle show/close handler
  const closeBtn = document.querySelector("#upload-video .btn-close");
  closeBtn.addEventListener("click", () => {
    videoDiv.className = "d-none";
  });

  // upload handler
  const submitButton = document.querySelector("#submit-video");
  submitButton.addEventListener("click", async (e) => {
    e.preventDefault();
    showLoader();
    try {
      let fileInput = document.querySelector("#videoFile");

      if (fileInput.value === "") {
        setError(true);
        setMsg("Please select video file!!");
        hideLoader();
        return;
      }

      document.querySelector("#custom-loader").style["z-index"] = 9999;

      const formData = new FormData();
      Object.keys(fileInput.files).forEach((key) => {
        formData.append("asset", fileInput.files.item(key));

        // formData.append("asset", e.dataTransfer.files[fileData]);
      });

      submitButton.setAttribute("disabled", true);
      submitButton.textContent = "Uploading...";

      const response = await postRequest(
        `assets/${pathName}/videos`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      submitButton.removeAttribute("disabled");
      submitButton.textContent = "Add Video";

      if (response.data.isSuccess) {
        if (response.data.assetData.length > 0) {
          setError(false);
          setMsg("Video uploaded successfully");
        } else {
          setError(false);
          setMsg("Video uploaded successfully");
          await editor.store();
          window.location.reload();
        }
      } else {
        setError(true);
        setMsg(response.data.msg);
      }

      document.querySelector("#custom-loader").removeAttribute("style");

      fileInput.value = "";

      updateVideoList(
        editor,
        pathName,
        videoComponent,
        setMsg,
        setError,
        presentation
      );
    } catch (error) {
      setError(true);
      setMsg(error);
    }
    hideLoader();
  });
  updateVideoList(
    editor,
    pathName,
    videoComponent,
    setMsg,
    setError,
    presentation
  );
};

export const getVideoSrcList = async (pageId) => {
  const response = await getRequest(`assets/listVideos/${pageId}`);
  if (response.data.isSuccess) {
    let videoNames = response.data.msg;
    const slugName = localStorage.getItem("slug");
    let videoSrcList = videoNames.map((videoName) => {
      let videoObject = {};
      let videoSrc = `${API_HOST}videos/${slugName}/${videoName}`;
      videoObject.id = videoSrc;
      videoObject.name = videoName;
      return videoObject;
    });
    if (videoSrcList.length === 0) {
      videoSrcList.push({
        id: "",
        name: "Please upload a video through Video Manager",
      });
    }
    return videoSrcList;
  } else
    return [{ id: "", name: "Please upload a video through Video Manager" }];
};
